import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Tabs, Tab } from 'react-bootstrap';
import OrgManagement from './OrgManagement';
import TagManagement from './TagManagement';
import UserManagement from './UserManagement';

const Admin = () => {
  // Cheep solution to get navbar to the correct state, need to figure 
  // out how to get navbar updated better
  const location = useLocation();

  useEffect(() => {
    if (location.state?.fromLogin) {
      // Clear the state to prevent infinite reloads
      window.history.replaceState({}, document.title);
      window.location.reload();
    }
  }, [location.state]);

  return (
    <Container className="mt-4">
      <Tabs defaultActiveKey="organization" id="admin-tabs" className="mb-3">
        {/* Organization Management Tab */}
        <Tab eventKey="organization" title="Organization Management">
          <OrgManagement />
        </Tab>

        {/* Tag Management Tab */}
        <Tab eventKey="tags" title="Tag Management">
          <TagManagement />
        </Tab>

        {/* User Management Tab with Sub-Tabs */}
        <Tab eventKey="users" title="User Management">
          <Tabs
            defaultActiveKey="approved"
            id="user-management-sub-tabs"
            className="mt-3"
          >
            <Tab eventKey="approved" title="Approved Users">
              <UserManagement filter="approved" />
            </Tab>
            <Tab eventKey="unapproved" title="Unapproved Users">
              <UserManagement filter="unapproved" />
            </Tab>
          </Tabs>
        </Tab>
      </Tabs>
    </Container>
  );
};

export default Admin;
